<template>
  <div v-if="breadcrumb.length > 0" class="secondBreadcrumb">
    <a-breadcrumb :routes="breadcrumb" separator="/">
      <template #itemRender="{ route, routes }">
        <span v-if="routes.indexOf(route) === routes.length - 1" class="breadcrumb-active">
          {{ route.name }}
        </span>
        <span v-else :class="route.isStop ? 'breadcrumb-cursorClass' : 'breadcrumb-normal'" @click="breadCrumbClick(route)">
          {{ route.name }}
        </span>
      </template>
    </a-breadcrumb>
  </div>
</template>
<script lang="ts" setup>
import { computed, ref } from "vue";
import { useRoute, type Router } from "vue-router";
import { useRbacStore } from "../../DefaultRbacPagePlugin";

const router = useRoute();
const rbacStore = useRbacStore();

const breadCrumbClick = (route: Router) => {
  // if(route.isStop) {
  //    this.$router.push({
  //       path:route.path
  //    });
  // }
};

const breadcrumb = computed(() => {
  const path = router.path;
  const pathArray = ref<{ name: string; link: string }[]>([]);
  if (path !== "") {
    const { idMap, pathMap } = rbacStore.menus;
    const menu = pathMap[path];
    if (menu) {
      pathArray.value.push({ name: menu.name as string, link: menu.linkTo as string });
      let parent = idMap[menu.parentId || ""];
      while (parent && parent.id && parent.name !== "管理控制台") {
        pathArray.value.push({ name: parent.name as string, link: parent.linkTo as string });
        parent = idMap[parent.parentId || ""];
      }
    }
  }
  return pathArray.value.reverse();
});
</script>

<style lang="less" scoped>
.secondBreadcrumb {
  width: 100%;
  padding: 16px 32px;
  height: 100%;
  display: flex;
  align-items: center;

  .breadcrumb-active {
    font-size: 16px;
    font-family: 'Microsoft YaHei Bold';
    color: #111111;
    line-height: 22px;
  }

  .breadcrumb-normal {
    font-size: 14px;
    font-family: 'Microsoft YaHei';
    color: #999999;
    line-height: 22px;
  }

  .breadcrumb-title {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 28px;
  }
}
</style>
